// UI-related constants used across the application

// Common notification timeout duration (in milliseconds)
export const NOTIFICATION_TIMEOUT_MS = 6000;